import { Modal } from "antd";
import React from "react";
import WorkersForm from "../../worker-details-form/WorkerDetailsForm";
import AdminForm from "../../admin-details-form/AdminForm";
import WorkersDeleteModal from "./WorkersDeleteModal";
import ArchiveCard from "./WorkerArchiveCard";
import UnArchiveCard from "./WorkerUnArchiveCard";

interface WorkersDetailsModalProps {
  formType:
    | "edit_worker"
    | "edit_admin"
    | "delete_worker"
    | "archive_worker"
    | "un_archive_worker";
  visible: boolean;
  onCancel: () => void;
  title: string;
  mutationType: "edit" | "add";
  setModalVisible: (visible: boolean) => void;
  worker?: any; // Replace 'any' with actual type of worker if available
}

const WorkersDetailsModal: React.FC<WorkersDetailsModalProps> = ({
  formType,
  visible,
  onCancel,
  title,
  mutationType,
  setModalVisible,
  worker,
}) => {



  const renderFormContent = () => {
    switch (formType) {
      case "edit_worker":
        return (
          <WorkersForm
            mutationType={mutationType}
            handleCancel={onCancel}
            worker={worker}
          />
        );
      case "edit_admin":
        return (
          <AdminForm
            mutationType="edit"
            onCancel={onCancel}
            item={worker}
          />
        );
      case "delete_worker":
        return <WorkersDeleteModal worker={worker} onCancel={onCancel} />;
      case "archive_worker":
        return (
          <ArchiveCard
            name={worker?.name}
            onCancel={onCancel}
            worker={worker}
          />
        );
      case "un_archive_worker":
        return (
          <UnArchiveCard
            name={worker?.name}
            onCancel={onCancel}
            worker={worker}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      title={<span className="dynamic-modal">{title}</span>}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={700}
    >
      {renderFormContent()}
    </Modal>
  );
};

export default WorkersDetailsModal;
